var map = {
	"./Diatom_12 (1).jpg": 3938,
	"./Diatom_12 (2).jpg": 548,
	"./Globigerinas_01.jpg": 5136,
	"./Globigerinas_02.jpg": 8899,
	"./Globigerinas_04.jpg": 8853,
	"./Globigerinas_09.jpg": 8186,
	"./Globigerinas_10.jpg": 6512,
	"./Globigerinas_11.jpg": 1978,
	"./Globigerinas_19.jpg": 2051,
	"./Globigerinas_20.jpg": 4415,
	"./Globigerinas_coccoliths_12 (1).jpg": 8391,
	"./Globigerinas_coccoliths_12 (2).jpg": 2612,
	"./Globigerinas_coccoliths_12 (5).jpg": 396,
	"./Radiolaria_38 (2).jpg": 1522,
	"./Radiolarians_02.jpg": 2230,
	"./Radiolarians_03.jpg": 4345,
	"./Radiolarians_04.jpg": 8270,
	"./Radiolarians_06.jpg": 6288,
	"./Radiolarians_07.jpg": 5457,
	"./Radiolarians_08.jpg": 6093,
	"./Radiolarians_13.jpg": 6265,
	"./Radiolarians_14.jpg": 1584,
	"./Radiolarians_15.jpg": 9444,
	"./Radiolarians_16.jpg": 8459,
	"./Radiolarians_17.jpg": 615,
	"./Radiolarians_18.jpg": 3057,
	"./Radiolarians_19.jpg": 1015,
	"./Radiolarians_20.jpg": 8078,
	"./Radiolarians_22.jpg": 7977,
	"./Radiolarians_23.jpg": 7025,
	"./Radiolarians_26.jpg": 7215,
	"./Radiolarians_27.jpg": 2431,
	"./SDNHM_36.jpg": 1691,
	"./SDNHM_Fossil_Foraminifera_34 (1).jpg": 1886,
	"./SDNHM_Fossil_Foraminifera_34 (14).jpg": 1626,
	"./SDNHM_Fossil_Foraminifera_34 (15).jpg": 9840,
	"./SDNHM_Fossil_Foraminifera_34 (17).jpg": 1034,
	"./SDNHM_Fossil_Foraminifera_34 (19).jpg": 6629,
	"./SDNHM_Fossil_Foraminifera_34 (28).jpg": 3326,
	"./SDNHM_Fossil_Foraminifera_34 (29).jpg": 8433,
	"./SDNHM_Fossil_Foraminifera_34 (31).jpg": 685,
	"./SDNHM_Fossil_Foraminifera_34 (32).jpg": 1547,
	"./SDNHM_Fossil_Foraminifera_34 (4).jpg": 4827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6978;